export default __webpack_public_path__ + "static/media/image-board-study-now-n-m@3x.3a991b5d.png";